import { Sites } from '@ps/platform-message-framework/common/Sites';
import { select } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import NewCAONSignupCountryImage from '../../assets/caon-signup-country-image.jpg';
import NewESSignupCountryImage from '../../assets/es-signup-country-image.jpg';
import NewUkSignupCountryImage from '../../assets/new-uk-signup-country-image.png';
import NewPTSignupCountryImage from '../../assets/pt-signup-country-image.jpg';
import NewROSignupCountryImage from '../../assets/ro-signup-country-image.jpg';
import SignupCountryDefaultImage from '../../assets/signup-country-default.png';

import { imageContainer } from './SignupCountryImageByLicence.scss';

const SignupCountryImageByLicence = () => {
  const siteId = useSelector(select.cms.getSiteId);

  const getImageByLicence = () => {
    switch (!!siteId) {
      case siteId === Sites.CA_ON:
        return <img src={NewCAONSignupCountryImage} width="100%" alt="Welcome" />;
      case siteId === Sites.UK:
        return <img src={NewUkSignupCountryImage} width="100%" alt="Welcome" />;
      case siteId === Sites.SPA:
        return <img src={NewESSignupCountryImage} width="100%" alt="Welcome" />;
      case siteId === Sites.POR:
        return <img src={NewPTSignupCountryImage} width="100%" alt="Welcome" />;
      case siteId === Sites.ROM:
        return <img src={NewROSignupCountryImage} width="100%" alt="Welcome" />;
      default:
        return <img src={SignupCountryDefaultImage} width="100%" alt="Welcome" />;
    }
  };

  return <div className={imageContainer}>{getImageByLicence()}</div>;
};

export default SignupCountryImageByLicence;
